var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "instagram_svg__a",
    cx: -664.4,
    cy: 176.43,
    r: 1.63,
    fx: -664.4,
    fy: 176.43,
    gradientTransform: "matrix(16 0 0 -16 10635 2845)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#f78f25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#d92e7e"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#instagram_svg__a)",
    d: "M8.67 12c0-1.84 1.49-3.33 3.33-3.33s3.33 1.49 3.33 3.33-1.49 3.33-3.33 3.33S8.67 13.84 8.67 12m-1.8 0c0 2.84 2.3 5.13 5.14 5.13s5.14-2.3 5.14-5.13-2.3-5.13-5.14-5.13S6.87 9.17 6.87 12m9.27-5.34c0 .66.54 1.2 1.2 1.2s1.2-.54 1.2-1.2-.54-1.2-1.2-1.2-1.2.54-1.2 1.2M7.96 20.14c-.97-.04-1.5-.21-1.86-.34-.47-.18-.8-.4-1.15-.75a3.06 3.06 0 0 1-.75-1.15c-.14-.35-.3-.88-.34-1.86-.05-1.05-.06-1.37-.06-4.04s.01-2.99.06-4.04c.04-.97.21-1.5.34-1.86.18-.47.4-.8.75-1.15s.68-.57 1.15-.75c.35-.14.88-.3 1.86-.34C9.01 3.81 9.33 3.8 12 3.8s2.99.01 4.04.06c.97.04 1.5.21 1.86.34.47.18.8.4 1.15.75s.57.68.75 1.15c.14.35.3.88.34 1.86.05 1.05.06 1.37.06 4.04s0 2.99-.06 4.04c-.04.97-.21 1.5-.34 1.86-.18.47-.4.8-.75 1.15s-.68.57-1.15.75c-.35.14-.88.3-1.86.34-1.05.05-1.37.06-4.04.06s-2.99 0-4.04-.06M7.88 2.06c-1.06.05-1.79.22-2.43.46-.66.26-1.21.6-1.77 1.15-.56.56-.9 1.11-1.15 1.77-.25.64-.42 1.36-.46 2.43-.05 1.07-.06 1.41-.06 4.12s.01 3.06.06 4.12.22 1.79.46 2.43c.26.66.6 1.22 1.15 1.77.56.56 1.11.9 1.77 1.15.64.25 1.36.42 2.43.46 1.07.05 1.41.06 4.12.06s3.06-.01 4.12-.06 1.79-.22 2.43-.46c.66-.26 1.21-.6 1.77-1.15s.9-1.11 1.15-1.77c.25-.64.42-1.36.46-2.43.05-1.07.06-1.41.06-4.12s-.01-3.06-.06-4.12-.22-1.79-.46-2.43c-.26-.66-.6-1.21-1.15-1.77-.56-.56-1.11-.9-1.77-1.15-.64-.25-1.36-.42-2.43-.46C15.05 2.01 14.71 2 12 2s-3.06.01-4.12.06"
  })));
};
export default SvgInstagram;